@if (rolesControlEnabled && !isPeerProgram) {
  <div class="u-marginBottom-small" fxLayout="column" fxLayoutGap="8px">
    <nz-form-label
      [style.text-align]="'left'"
      class="text-subtitle-2"
      nzRequired
      i18n="@@programParticipantPreferencesForm.chooseRoleLabel"
      >Choose your role</nz-form-label
    >
    <app-ttc-segmented
      [options]="segmentedRoleOptions"
      [selected]="selectedRoleOption"
      [(ngModel)]="selectedRoleOption"
      (ngModelChange)="updateRoleControl($event)"
    ></app-ttc-segmented>
  </div>
}
@if ('mentor,mentee' === selectedRoleOption?.value) {
  <div
    class="background-color-primary u-padding-default u-borderRadius-inner-card u-marginBottom-small color-subdued"
    fxLayout="row"
    fxLayoutGap="8px"
  >
    <mat-icon class="md-18" fontSet="material-icons-outlined">info</mat-icon>
    <p i18n="@@programParticipantPreferencesForm.bothSelected.caption">
      You will participate as both roles if there are available matches. If not,
      you will participate as either a
      {{ programRoles[0].label }} or a {{ programRoles[1].label }}.
    </p>
  </div>
}
<form [formGroup]="form">
  @if (preferredMatchesControlEnabled) {
    <div
      [@fadeInEnter]
      class="u-marginBottom-16"
      fxLayout="column"
      fxLayoutGap="8px"
    >
      <div class="text-subtitle-2">
        @if (isPeerProgram) {
          <ng-container i18n="@@programParticipantPreferencesForm.peerLabel">
            Preferred matches
          </ng-container>
        } @else {
          <ng-container
            i18n="@@programParticipantPreferencesForm.mentorMenteeLabel"
          >
            Preferred {{ programRoles[0].pluralLabel }} or
            {{ programRoles[1].pluralLabel }}
          </ng-container>
        }
      </div>
      <nz-select
        [nzMaxMultipleCount]="5"
        formControlName="preferred_matches"
        nzMode="multiple"
      >
        @for (account of filteredAccounts; track account._id) {
          <nz-option
            [nzLabel]="account | appAccountFullName"
            [nzValue]="account?._id"
          ></nz-option>
        }
      </nz-select>
      <span
        class="text-caption color-gray-300"
        i18n="@@programParticipantPreferencesForm.preferencesNote"
        >We will take your preferences into consideration when matching.</span
      >
    </div>
  }
  @if (
    capacityControlEnabled &&
    rolesControl.getRawValue() &&
    programRoles[1]?.value !== rolesControl.getRawValue()
  ) {
    <div [@fadeInEnter] fxLayout="column">
      <nz-form-label
        [style.text-align]="'left'"
        class="text-subtitle-2"
        nzLabelWrap
        nzNoColon
        nzRequired
        i18n="@@programParticipantPreferencesForm.capacityLabel"
      >
        How many
        {{
          isPeerProgram
            ? programRoles[0].pluralLabel
            : programRoles[1].pluralLabel
        }}
        are you comfortable being paired with?
      </nz-form-label>
      <p class="color-text-subdued u-marginBottom-small">
        @if (program.features_enabled?.group_communications) {
          <ng-container
            i18n="@@programParticipantPreferencesForm.capacityCaption"
            >You would meet them in a group, not individually</ng-container
          >
        } @else {
          <ng-container
            i18n="@@programParticipantPreferencesForm.groupCapacityCaption"
            >You would meet with them individually, not as a
            group.</ng-container
          >
        }
      </p>
      <nz-input-number
        [nzMax]="program.max_match_capacity ?? defaultProgramMaxCapacity"
        [nzMin]="1"
        [nzStep]="1"
        class="u-marginTop-xsmall"
        formControlName="capacity"
      ></nz-input-number>
    </div>
  }
</form>
